import { httpservice } from '../services';
import { constants } from '../constant/constant';
import AuthService from '../services/AuthService';

const doLogin = async (credential, ssoObject) => {
  const loginData = await httpservice()
    .post(`${constants.API.LOGIN}?sso=${ssoObject.sso}&redirect_uri=${ssoObject.redirectURI}&portal=${ssoObject.portal}`, credential)
    .then((response) => ({ status: 1, data: response.data }))
    .catch((error) => {
      if (!error.response) {
        return { status: 0, data: 'Network Error' };
      }

      return { status: 0, data: error.response && error.response.data ? error.response.data : error };
    });

  if (loginData.data.response && loginData.data.response.token) {
    AuthService.authenticate(loginData.data.response.token);
    await httpservice()
      .get(constants.API.SOCKET_TOKEN)
      .then((response) => {
        if (response.data && response.data.response && response.data.response.socketToken) {
          sessionStorage.socketToken = response.data.response.socketToken;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return loginData;
};

export default doLogin;
